import * as React from 'react'
import { MarketingLayout } from '../components/marketing-layout'
import { MarketingPageContainer, PageTitle, PageSubtitle, MarketingSection } from '../styles/marketing.styles'

export const SecurityPage: React.FC = () => (
  <MarketingLayout>
    <MarketingPageContainer>
      <MarketingSection>
        <PageTitle>Security</PageTitle>
        <PageSubtitle>How we protect your data.</PageSubtitle>
      </MarketingSection>
      <MarketingSection>
        <h2>Encryption</h2>
        <p>Data is encrypted in transit (TLS) and at rest. We use industry-standard encryption for all sensitive data.</p>
      </MarketingSection>
      <MarketingSection>
        <h2>Authentication</h2>
        <p>We support Google OAuth and email/password authentication with secure session handling.</p>
      </MarketingSection>
      <MarketingSection>
        <h2>Access control</h2>
        <p>Role-based access control ensures users only see and modify what they are permitted to.</p>
      </MarketingSection>
      <MarketingSection>
        <h2>Hosting</h2>
        <p>Our infrastructure runs on Google Cloud Platform with strict access and monitoring.</p>
      </MarketingSection>
    </MarketingPageContainer>
  </MarketingLayout>
)
